module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"パフォーマンス","title_tooltip":"異なる２つ以上のロケーションのパフォーマンを同じ期間内で比較することができます。また、各ロケーションのKPIが表示されているテーブルから１つKPIをクリックすると、折れ線グラフ上に選択されたKPIのトレンドが表示されます。","maximum2selections":"6店舗以上選択できません。","minimum2selections":"２店舗以上を選択してください。"}}')
  delete Component.options._Ctor
}
